import { render, staticRenderFns } from "./VAmount.vue?vue&type=template&id=3ab4acd0&"
import script from "./VAmount.vue?vue&type=script&lang=js&"
export * from "./VAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports